import { msg } from '@lingui/core/macro';
import { OldSubCategoryType } from '@/@types';

const moviesFilters = [
  { title: msg`Comedy`, name: 'Comedy', id: 'Comedia' },
  { title: msg`Documental`, name: 'Documental', id: 'Documental' },
  { title: msg`Action`, name: 'Action', id: 'Acción' },
  { title: msg`Historia`, name: 'Historia', id: 'Historia' },
  { title: msg`Music`, name: 'Music', id: 'Música' },
  { title: msg`Animation`, name: 'Animation', id: 'Animación' },
  { title: msg`Horror`, name: 'Horror', id: 'Terror' },
  { title: msg`Adventure`, name: 'Adventure', id: 'Aventura' },
  { title: msg`Family`, name: 'Family', id: 'Familia' },
  { title: msg`Drama`, name: 'Drama', id: 'Drama' },
  { title: msg`Crime`, name: 'Crime', id: 'Crimen' },
  { title: msg`Romance`, name: 'Romance', id: 'Romance' },
  { title: msg`Western`, name: 'Western', id: 'Western' },
  { title: msg`Fantasy`, name: 'Fantasy', id: 'Fantasía' },
  { title: msg`War`, name: 'War', id: 'Bélica' },
  { title: msg`Suspense`, name: 'Suspense', id: 'Suspense' },
  { title: msg`Sci-Fi`, name: 'Sci-Fi', id: 'Ciencia ficción' },
  { title: msg`Mistery`, name: 'Mistery', id: 'Misterio' },
  { title: msg`TV Movie`, name: 'TV Movie', id: 'Película de TV' },
] as OldSubCategoryType[];

export default moviesFilters;
